<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                <mat-icon>event</mat-icon>
                {{'Calendar'|translate}} - {{resource.name}}
            </span>
            <button mat-icon-button (click)="onNoClick()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0">
        <div *ngIf="reservations.length === 0" class="no-reservations">
            <mat-icon>event_busy</mat-icon>
            <p>{{'No upcoming sessions for this device today'|translate}}</p>
        </div>

        <div *ngIf="reservations.length > 0" class="reservations-list">
            <div class="reservation-item" *ngFor="let reservation of reservations">
                <div class="reservation-header">
                    <div class="time-info">
                        <mat-icon>schedule</mat-icon>
                        <span>{{reservation.startDate | date:'HH:mm'}} - {{reservation.endDate | date:'HH:mm'}}</span>
                    </div>
                </div>

                <div class="reservation-details">
                    <div class="detail-row" *ngIf="reservation.service">
                        <mat-icon>spa</mat-icon>
                        <span class="label">{{'Service'|translate}}:</span>
                        <span class="value">{{reservation.service.name}}</span>
                    </div>

                    <div class="detail-row" *ngIf="reservation.reservedUsers && reservation.reservedUsers.length > 0">
                        <mat-icon>person</mat-icon>
                        <span class="label">{{'Client'|translate}}:</span>
                        <span class="value">{{reservation.reservedUsers[0]?.firstName}} {{reservation.reservedUsers[0]?.lastName}}</span>
                    </div>

                    <div class="detail-row" *ngIf="reservation.reservedUsers && reservation.reservedUsers.length > 1">
                        <mat-icon>supervised_user_circle</mat-icon>
                        <span class="label">{{'Employee'|translate}}:</span>
                        <span class="value">{{reservation.reservedUsers[1]?.firstName}} {{reservation.reservedUsers[1]?.lastName}}</span>
                    </div>

                    <div class="detail-row" *ngIf="reservation.description">
                        <mat-icon>notes</mat-icon>
                        <span class="label">{{'Description'|translate}}:</span>
                        <span class="value">{{reservation.description}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
